import { render } from "./aui-footer.vue?vue&type=template&id=9c0047c2&scoped=true"
import script from "./aui-footer.vue?vue&type=script&lang=js"
export * from "./aui-footer.vue?vue&type=script&lang=js"

import "./aui-footer.vue?vue&type=style&index=0&id=9c0047c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0047c2"]])

export default __exports__